module.exports = __webpack_public_path__ + "img/recycle.56ade1bc.svg";